namespace Areas.Finance.IrsDeclarations {
    "use strict";

    export function onRowUpdating (options: any) {
        // Force it to send appropriate data for below fields even though they are not been modified.
        // This is because of the custome SaveAccountMilestoneCommand which was overwriting data not modified.
        options.newData.accountId = options.oldData.accountId;
        options.newData.accountMilestoneId = options.oldData.accountMilestoneId;
        if (options.newData.milestoneDate === undefined) {
            options.newData.milestoneDate = options.oldData.milestoneDate;
        }
        if (options.newData.milestoneNote === undefined) {
            options.newData.milestoneNote = options.oldData.milestoneNote;
        }
        if (options.newData.irsDeclarationAmount === undefined) {
            options.newData.irsDeclarationAmount = options.oldData.irsDeclarationAmount;
        }
        if (options.newData.includeInReport === undefined) {
            options.newData.includeInReport = options.oldData.includeInReport;
        }
    }

    export function viewMilestoneLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            "<a href= '/Account/Milestones/View/{placeholder}'>View Milestone</a>");
    }
}